export default [
  // {
  //   text: 'ID',
  //   value: 'id',
  // },
  {
    text: 'Folio NC',
    value: 'number',
  },
  {
    text: 'Fecha Emisión',
    value: 'created_at',
    format: 'date',
  },
  {
    text: 'Documento Ref ',
    value: 'typeDocument',
  },
  {
    text: 'Folio Ref',
    value: 'numberRerefence'
  },
  {
    text: 'Neto',
    value: 'net_total',
    format : 'currency'
  },
  {
    text: 'IVA',
    value: 'iva',
    format : 'currency'
  },
  {
    text: 'Total',
    value: 'total',
    format : 'currency'
  }
  // {
  //     text: 'FECHA EMISIÓN',
  //     value: 'emission_date',
  // },
  // {
  //     text: 'ESTADO',
  //     value: 'state',
  // },
  // {
  //     text: 'NETO',
  //     value: 'net_total',
  //     format: 'currency',
  // },
  // {
  //     text: 'IVA',
  //     value: 'iva',
  //     format: 'currency',
  // },
  // {
  //     text: 'TOTAL',
  //     value: 'total',
  //     format: 'currency',
  // },
]
